import React, { useEffect, useState } from "react";
import { Route } from "react-router";
import authApiService from "../adapters/xhr/AuthApiService";

export const RouteWithLayout = ({ component: Component, layout: Layout, shouldIgnoreAntiforgeryToken, ...rest }) => {
  const [didGetAntiforgeryToken, setDidGetAntiforgeryToken] = useState(false);

  useEffect(() => {
    if (shouldIgnoreAntiforgeryToken === true) {
      setDidGetAntiforgeryToken(true);
    } else {
      authApiService.createAntiforgeryToken(() => setDidGetAntiforgeryToken(true));
    }
  });

  if (!didGetAntiforgeryToken) {
    return <div></div>;
  }

  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
    />
  );
};
